/* More Tomorrows member Blueprint viewer — dev theme only.
 * No innerHTML: member content is always rendered as plain text.
 * The bearer token is supplied by the authenticated member session in memory.
 */
(function (global) {
  'use strict';
  const ENDPOINT = 'https://vcnahddnbmbjbksejwli.supabase.co/functions/v1/blueprint-generate';
  function make(tag, text, className) {
    const node = document.createElement(tag);
    node.textContent = String(text).replace(/\\\*/g, '*').replace(/\*\*([^*]+)\*\*/g, '$1').replace(/\*([^*]+)\*/g, '$1');
    if (className) node.className = className;
    return node;
  }
  function render(root, result) {
    root.replaceChildren();
    if (!result || !result.blueprint) {
      root.append(make('p', 'Your Blueprint will appear here after you complete your assessment.', 'mt-blueprint-empty'));
      return;
    }
    const blueprint = result.blueprint;
    const content = blueprint.content || {};
    if (typeof content.member_blueprint_markdown !== 'string') throw new Error('Unexpected Blueprint format');
    const article = make('article', '', 'mt-blueprint-text');
    let list = null;
    for (const line of content.member_blueprint_markdown.split('\n')) {
      if (!line.trim()) { list = null; continue; }
      const heading = line.match(/^(#{1,6})\s+(.+)$/);
      const item = line.match(/^\s*(?:[-*]|\d+\.)\s+(.+)$/);
      if (heading) {
        list = null;
        article.append(make('h' + Math.min(heading[1].length + 1, 6), heading[2]));
      } else if (item) {
        if (!list) { list = make('ul', ''); article.append(list); }
        list.append(make('li', item[1]));
      } else {
        list = null;
        article.append(make('p', line));
      }
    }
    root.append(article);
    const printButton=make('button','Download PDF','mt-blueprint-button mt-blueprint-print');
    printButton.type='button';
    printButton.addEventListener('click',async()=>{
      printButton.disabled=true;printButton.textContent='Preparing PDF…';
      try {const access=document.getElementById('mt-member-access');const session=await global.MoreTomorrowsMember.getSession();
        const response=await fetch(ENDPOINT,{method:'POST',cache:'no-store',headers:{Authorization:'Bearer '+session.access_token,apikey:access.dataset.publishableKey,'Content-Type':'application/json'},body:JSON.stringify({action:'pdf'})});
        if(!response.ok||!response.headers.get('content-type')?.includes('application/pdf'))throw Error('Unable to download PDF. Please try again.');
        const blob=await response.blob();const url=URL.createObjectURL(blob);const link=document.createElement('a');link.href=url;link.download='More-Tomorrows-Blueprint.pdf';document.body.append(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
      }catch(e){const error=make('p',e.message,'mt-blueprint-error');root.append(error);}
      finally{printButton.disabled=false;printButton.textContent='Download PDF';}
    });
    root.append(printButton);
  }
  async function load(root, token, apikey, action = 'read') {
    if (!root || typeof root.replaceChildren !== 'function') throw new Error('Missing Blueprint container');
    if (typeof token !== 'string' || !token) throw new Error('Sign in required');
    if (typeof apikey !== 'string' || !apikey) throw new Error('Missing public Supabase key');
    root.replaceChildren(make('p', action === 'generate' ? 'Creating your Blueprint…' : 'Loading your Blueprint…'));
    root.setAttribute?.('aria-busy', 'true');
    try {
      const response = await fetch(ENDPOINT, {
        method: 'POST', mode: 'cors', cache: 'no-store',
        headers: { Authorization: `Bearer ${token}`, apikey, 'Content-Type': 'application/json' },
        body: JSON.stringify({ action })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(response.status === 409 ? 'Complete your assessment first.' :
        response.status === 401 ? 'Your session expired. Please sign in again.' :
        response.status === 422 ? 'Your assessment needs a review before we can create your Blueprint. Please contact More Tomorrows for help.' :
        'Your Blueprint is temporarily unavailable. Please try again.');
      render(root, data);
      return data;
    } catch (error) {
      root.replaceChildren(make('p', error.message || 'Unable to load Blueprint.', 'mt-blueprint-error'));
      return null;
    } finally {
      root.setAttribute?.('aria-busy', 'false');
    }
  }
  // Session provider is called on every action so refreshed access tokens are used.
  async function mount(root, getSession, apikey) {
    let busy = false;
    const controls = make('div', '', 'mt-blueprint-controls');
    const status = make('p', '', 'mt-blueprint-status');
    status.setAttribute?.('role', 'status');
    const content = make('section', '', 'mt-blueprint-content');
    content.setAttribute?.('aria-live', 'polite');
    const button = make('button', 'Show me my plan', 'mt-blueprint-button');
    button.type = 'button';
    controls.append(button);
    controls.append(status);
    root.replaceChildren(content, controls);
    async function run(action) {
      if (busy) return;
      busy = true; button.disabled = true; status.textContent = '';
      try {
        const session = await getSession();
        const result = await load(content, session?.access_token, apikey, action);
        button.hidden = Boolean(result?.blueprint);
        if (!result) { button.textContent = 'Try again'; }
        else if (!result.blueprint) { button.textContent = 'Show me my plan'; }
        return result;
      } catch {
        content.replaceChildren(make('p', 'Please sign in to view your Blueprint.', 'mt-blueprint-error'));
        button.hidden = true;
      } finally { busy = false; button.disabled = false; }
    }
    button.addEventListener('click', () => run('generate'));
    await run('read');
    return { refresh: () => run('read') };
  }
  global.MoreTomorrowsBlueprint = { load, render, mount };
})(typeof window === 'undefined' ? globalThis : window);

(function(){
  const host=document.getElementById('mt-blueprint');
  const access=document.getElementById('mt-member-access');
  if(!host||!access)return;
  const result=host.querySelector('[data-mt-blueprint-result]');
  const refresh=host.querySelector('[data-mt-blueprint-refresh]');
  let token=null,controller=null;
  access.addEventListener('mt:authenticated',event=>{token=event.detail?.accessToken||null;controller=null;refresh.hidden=true;});
  document.addEventListener('mt:view-blueprint',async()=>{if(!token)return;if(controller)await controller.refresh();else controller=await MoreTomorrowsBlueprint.mount(result,async()=>window.MoreTomorrowsMember.getSession(),access.dataset.publishableKey);});
  document.addEventListener('mt:assessment-completed',()=>{controller=null;});
  refresh.addEventListener('click',()=>controller?.refresh());
  window.addEventListener('pagehide',()=>{token=null;controller=null;result.replaceChildren();});
})();
